import App from '@components/spaces/spaceCta.vue'
import { generateApplication } from '@helpers/generate_component.js';

generateApplication(App, "#hire-banner__right", {
    injections: [{ name: 'locale', module: locale }],
    props: {
        product :  product
    },
})